import React from "react";
import { withRouter } from "react-router-dom";
import { PageSettings } from "./../config/page-settings.js";
import { Api } from "./../app-controller.js";

class EmailConfirm extends React.Component {
  static contextType = PageSettings;

  /* constructor(props) {
    	super(props);
   } */

  componentDidMount() {
    this.context.handleSetPageSidebar(false);
    this.context.handleSetPageHeader(false);
    this.context.handleSetPageContentFullWidth(true);

    var token = this.props.match.params[0];
    Api.xhr("public/confirmEmail", { mailToken: token }, (r) => {
      let tag = document.getElementById("tag");
      tag.classList.remove("note-secundary");
      tag.classList.add("note-success");
      let bar = document.getElementById("bar");
      bar.style = "display:none";
      let msg = document.getElementById("msg");
      msg.innerHTML =
        "Tu cuenta ha sido confirmada con éxito, ahora puedes iniciar sesión.<br><br><a 	className='btn btn-primary' href='/login'>Click aquí para iniciar sesión</a>";
    });
  }

  componentWillUnmount() {
    this.context.handleSetPageSidebar(true);
    this.context.handleSetPageHeader(true);
    this.context.handleSetPageContentFullWidth(false);
  }

  render() {
    //console.log(Api.user_profile);
    // if (!Api.user_profile) {
    //   window.location.href = "/";
    // }

    return (
      <div className="login login-v1">
        <div className="login-container">
          <div className="login-header">
            <div className="brand">
              {/* <span className="logo " ></span>  */}
              <img
                className="logo"
                alt="Logo"
                style={{ width: "12%", height: "12%" }}
                src="../favicon.ico"
              ></img>
              <b>SINAIP</b>
            </div>
            <div className="icon">
              <i className="fa fa-envelope"></i>
            </div>
          </div>
          <div className="login-body">
            <div className="login-content">
              <div
                id="tag"
                className="note note-secundary note-with-right-icon"
              >
                <div className="note-icon">
                  <i className="fa fa-clock"></i>
                </div>
                <div className="note-content text-right">
                  <h4>
                    <b>
                      {" "}
                      {/* <span style={{ textTransform: "capitalize" }}>
                        {Api.user_profile.name}
                      </span>{" "} */}
                      <span id="msg">
                        Por favor espera mientras confirmamos tu cuenta.
                      </span>
                    </b>
                  </h4>
                  <div
                    id="bar"
                    className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
                  >
                    Confirmando cuenta
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(EmailConfirm);
